import { Constants } from './constants';

export class StringUtils {
  public static isEmpty(str: string) {
    if (str) {
      str = str.toString();
      const trimmedStr = str.trim();
      return trimmedStr === Constants.EMPTY_STRING;
    } else {
      return true;
    }
  }

  public static isNotEmpty(str: string) {
    if (str) {
      str = str.toString();
      const trimmedStr = str.trim();
      return trimmedStr !== Constants.EMPTY_STRING;
    } else {
      return false;
    }
  }

  public static join(array: string[], seperator?: string) {
    if (!seperator) {
      seperator = Constants.COMMA;
    }
    if (Array.isArray(array)) {
      return array.join(seperator);
    } else {
      return Constants.EMPTY_STRING;
    }
  }
}
